module.exports = __webpack_public_path__ + "static/media/comment-dollar.5e51588f.svg";